export const toMap = items => {
	const map = {};

	items.forEach(i => (map[i.id] = i));

	return map;
};
